module.exports = __webpack_public_path__ + "img/cloud.66e227f2.svg";